import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements AfterViewInit
{
  @ViewChild('canvas') public canvasEl!: ElementRef;

  @Input() public consentModel: any;
  @Input() public memberName: string;
  @Input() public memberNameFont = 'italic 20px Georgia';
  @Input() public memberTextAlign = 'left';
  @Input() public memberSignatureLeft = 20;
  @Input() public memberSignatureTop = 75;
  @Input() public height = 140;
  @Input() public width = 400;
  @Input() public submitButtonKey: string;
  @Input() public penColor = 'rgb(67, 113, 196)';
  @Input() public hiddingButtons = false;
  @Input() public bypassSignature = false;

  @Output() public submitSignature: EventEmitter<any> = new EventEmitter();

  public signaturePad!: SignaturePad;
  public signatureImage!: string;
  public signatureNeeded!: boolean;
  public eSigned = false;
  public signedDate = new Date();

  public ngAfterViewInit()
  {
    this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
    this.signaturePad.penColor = this.penColor;
  }

  public clearPad(): void
  {
    this.signaturePad.clear();
    this.signatureNeeded = false;
    this.eSigned = false;
  }

  public eSign(): void 
  {
    this.clearPad();

    const canvas = this.canvasEl.nativeElement;
    const ctx = canvas.getContext('2d');
    ctx.textAlign = this.memberTextAlign;
    ctx.font = this.memberNameFont;
    ctx.fillStyle = this.penColor;
    ctx.fillText(this.consentModel && this.consentModel.signedName || this.memberName,
      this.memberSignatureLeft, this.memberSignatureTop, this.width);

    this.eSigned = true;
  }

  public saveSignature(): void
  {
    this.signatureImage = this.signaturePad.toDataURL();
    this.signatureNeeded = this.signaturePad.isEmpty() && !this.eSigned;
    if (!this.signatureNeeded)
    {
      this.submitSignature.emit({ signature: this.signatureImage });
    }
  }

  public close(): void
  {
    this.submitSignature.emit({ signature: null });    
  }
}
